var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeightArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.08846 5.83333C1.44413 5.83333 0.921795 6.35567 0.921795 7C0.921795 7.64433 1.44413 8.16667 2.08846 8.16667H16.0885C16.7328 8.16667 17.2551 7.64433 17.2551 7C17.2551 6.35567 16.7328 5.83333 16.0885 5.83333H2.08846Z",
    fill: "#252A31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.74675 1.99162C9.20236 1.53601 9.20236 0.797321 8.74675 0.341709C8.29114 -0.113902 7.55245 -0.113902 7.09684 0.341709L1.2635 6.17504C0.807892 6.63065 0.807892 7.36935 1.2635 7.82496L7.09684 13.6583C7.55245 14.1139 8.29114 14.1139 8.74675 13.6583C9.20236 13.2027 9.20236 12.464 8.74675 12.0084L3.73838 7L8.74675 1.99162Z",
    fill: "#252A31"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeightArrowLeft);
export default __webpack_public_path__ + "static/media/WeightArrowLeft.268c7f77.svg";
export { ForwardRef as ReactComponent };